export const formatChecklistQuestions = (response) => {
  let questions = [];
  if (response.airIntakeAndExhaustSystemCheckList) {
    questions.push(
      convertToPDFQuestions(
        response.airIntakeAndExhaustSystemCheckList,
        "Air system details"
      )
    );
  }
  if (response.fuelSystem) {
    questions.push(convertToPDFQuestions(response.fuelSystem, "Fuel System"));
  }

  if (response.lubricationSystem) {
    questions.push(
      convertToPDFQuestions(response.lubricationSystem, "Lube System")
    );
  }

  if (response.coolantSystem) {
    questions.push(
      convertToPDFQuestions(response.coolantSystem, "Coolant Condition")
    );
  }

  if (response.overHeating) {
    questions.push(convertToPDFQuestions(response.overHeating, "Over Heated"));
  }

  if (response.electricalSystem) {
    questions.push(
      convertToPDFQuestions(response.electricalSystem, "Electrical System")
    );
  }

  if (response.otherEngineSystem) {
    questions.push(
      convertToPDFQuestions(response.otherEngineSystem, "Engine Side")
    );
  }

  if (response.engineConditionAfterDismantling) {
    questions.push(
      convertToPDFQuestions(
        response.engineConditionAfterDismantling,
        "Engine condition after dismantling"
      )
    );
  }

  if (response.vehicleEnd) {
    questions.push(convertToPDFQuestions(response.vehicleEnd, "Vehicle END"));
  }

  if (response.lubeOilConsumption) {
    questions.push(
      convertToPDFQuestions(response.lubeOilConsumption, "LOC Trial")
    );
  }

  if (response.otherObservation) {
    questions.push(
      convertToPDFQuestions(response.otherObservation, "Other Observation")
    );
  }

  return questions;
};
const convertToPDFQuestions = (questionsAndAnswers, title) => {
  const formattedQuestionsAndAnswers = [];

  const processObject = (obj, parentKey = "") => {
    Object.keys(obj).forEach((key) => {
      if (
        ["id", "archive", "ticket", "createdAt", "updatedAt", "jir"].includes(
          key
        )
      )
        return;

      const value = obj[key];

      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        // Recursively process nested objects
        processObject(value, parentKey ? `${key}` : key);
      } else {
        // Only include meaningful answers
        if (typeof value === "boolean" && value) {
          formattedQuestionsAndAnswers.push({
            question: convertString(parentKey),
            answer: convertString(key),
          });
        } else if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          typeof value !== "boolean" &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          formattedQuestionsAndAnswers.push({
            question: convertString(parentKey || key),
            answer: value,
          });
        }
      }
    });
  };

  processObject(questionsAndAnswers);
  return {
    title,
    questionsAndAnswers: formattedQuestionsAndAnswers,
  };
};

function convertString(input) {
  if (!input) {
    return "";
  }

  return input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between lowercase and uppercase
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2") // Handle consecutive uppercase letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
}
